import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { MusikSuchenFilterContainer } from "./MusikSuchenFilterContainer";

export const MusikSuchenFilter = ({ restoredFilter, onSearchChanged }) => {
  const handleSearchChanged = (filter) => {
    if (onSearchChanged) {
      onSearchChanged(filter);
    }
  };

  return (
    <Grid container spacing={{ xs: 1, sm: 3 }}>
      <Grid
        item
        xs={12}
        sx={{
          "& .MuiAutocomplete-root:not(:last-of-type)": {
            mb: 1,
          },
        }}
      >
        <Typography variant="h4" sx={{ mb: 1 }}>
          Filter
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <MusikSuchenFilterContainer
          restoredFilter={restoredFilter}
          onSearchChanged={handleSearchChanged}
        />
      </Grid>
    </Grid>
  );
};
